"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var orderRouter = {
  type: 1,
  path: '/sms-finance',
  component: _layout.default,
  redirect: '/sms-finance/agent-conversion-quota-list',
  name: '',
  meta: {
    title: 'financeManagement',
    icon: 'g-finance'
  },
  children: [{
    type: 2,
    path: 'agent-remit-order',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-finance-management/agent-remit-order'));
      });
    },
    name: 'agentRemitOrder:view',
    meta: {
      title: 'agentRemitOrder'
    },
    children: [{
      path: 'auditSuccess',
      name: 'agentRemitOrder:auditSuccess',
      hidden: true
    }, {
      path: 'auditFail',
      name: 'agentRemitOrder:auditFail',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'organization-remit-order',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-finance-management/organization-remit-order'));
      });
    },
    name: 'organizationRemitOrder:view',
    meta: {
      title: 'organizationRemitOrder'
    },
    children: [{
      path: 'auditSuccess',
      name: 'organizationRemitOrder:auditSuccess',
      hidden: true
    }, {
      path: 'auditFail',
      name: 'organizationRemitOrder:auditFail',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'organization-amount-change-record',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-finance-management/organization-amount-change-record'));
      });
    },
    name: 'organizationAmountChangeRecord:view',
    meta: {
      title: 'organizationAmountChangeRecord'
    },
    children: []
  }, {
    type: 2,
    path: 'agent-amount-change-record',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-finance-management/agent-amount-change-record'));
      });
    },
    name: 'agentAmountChangeRecord:view',
    meta: {
      title: 'agentAmountChangeRecord'
    },
    children: []
  }]
};
var _default = orderRouter;
exports.default = _default;